<template>
  <div class="card-form">
    <el-card>
      <el-row :gutter="20">
        <el-col :span="9">
          <b-img
            :src="
              formData.defaultImageUrl
                ? formData.defaultImageUrl
                : '/image/static/img/nopic.jpg'
            "
            @click="imageView"
            class="max-image"
          ></b-img>
          <div
            v-for="(item, index) in imageList"
            :key="index"
            style="width:90px;height:60px;margin-top:10px;margin-right:10px;float:left;"
          >
            <img
              @click="changeImage(item.thumbImageUrl)"
              :src="item.thumbImageUrl"
              class="image"
            />
          </div>
          <div v-show="false" class="images" v-viewer="{ movable: true }">
            <img
              v-for="src in imageList"
              :src="src.displayImageUrl"
              :key="src.displayImageUrl"
            />
          </div>
        </el-col>
        <el-col :span="15">
          <h3>{{ formData.sampleStyleNo }}</h3>
          <div>
            <b-icon-star
              v-for="(str, index) in formData.lightStarList"
              :key="index"
              :variant="str"
              class="mr-1"
            ></b-icon-star>
            <b-icon-star
              v-for="str in formData.greyStarList"
              :key="str"
              class="mr-3"
            ></b-icon-star>
            <span>{{ formData.reviews }} reviews</span>
          </div>
          <hr />
          <h5 class="price">
            Cost Price：
            <span class="text" style="font-size:22px;">
              {{ formData.costPrice ? formData.costPrice : '0.00' }}
            </span>
            <span class="text-currency">
              {{ formData.costCurrency ? formData.costCurrency : '' }}
            </span>
          </h5>
          <h5 class="price">
            {{ formData.quotedMethod }} Price：
            <span class="text-danger" style="font-size:22px;">
              {{ formData.quotedPrice ? formData.quotedPrice : '0.00' }}
            </span>
            <span class="text-currency">
              {{ formData.quotedCurrency ? formData.quotedCurrency : '' }}
            </span>
          </h5>
          <div class="mt-2" style="font-size: 16px; color:#666666">
            <el-row class="mt-2" :gutter="5">
              <el-col :span="24">
                <span>
                  {{
                    formData.sampleNameEn ? formData.sampleNameEn : '--'
                  }}</span
                >
              </el-col>
            </el-row>
            <el-row class="mt-2" :gutter="5">
              <el-col :span="10">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_size') || 'Size' }}：
                  </div>
                  <div class="text-value">
                    <span>
                      {{ formData.sampleSpec ? formData.sampleSpec : '--' }}
                      {{
                        formData.sampleSizeUnit ? formData.sampleSizeUnit : ''
                      }}
                    </span>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_weight') || 'Weight' }}：
                  </div>
                  <div class="text-value">
                    <span
                      >{{
                        formData.sampleWeight ? formData.sampleWeight : '--'
                      }}
                      {{
                        formData.sampleWeightUnit
                          ? formData.sampleWeightUnit
                          : ''
                      }}</span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_source') || 'Source' }}：
                  </div>
                  <div class="text-value">
                    <span>{{
                      formData.sampleSourceName
                        ? formData.sampleSourceName
                        : '--'
                    }}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_business_name') || 'salesPersonName' }}：
                  </div>
                  <div class="text-value">
                    <span>{{
                      formData.salesPersonName ? formData.salesPersonName : '--'
                    }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="10">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_brandName') || '品牌' }}：
                  </div>
                  <div class="text-value">
                    <span>{{
                      formData.brandName ? formData.brandName : '--'
                    }}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_customer') || '客户' }}：
                  </div>
                  <div class="text-value">
                    <span>{{
                      formData.custName ? formData.custName : '--'
                    }}</span>
                  </div>
                </div>
              </el-col>
              <el-row :gutter="5">
                <el-col :span="10">
                  <div class="d-flex">
                    <div class="text-title">
                      {{ $l('detail_label_sales_season') || '销售季节' }}：
                    </div>
                    <div class="text-value">
                      <span>{{
                        formData.sampleSalesSeasonName
                          ? formData.sampleSalesSeasonName
                          : '--'
                      }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-col :span="10">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_moq') || '起订量' }}：
                  </div>
                  <div class="text-value">
                    <span>
                      {{ formData.moq ? formData.moq : '--' }}
                      {{ formData.moqUnit ? formData.moqUnit : '' }}
                    </span>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <div class="d-flex">
                  <div class="text-title">
                    {{ $l('detail_label_supplier') || 'scmName' }}：
                  </div>
                  <div class="text-value">
                    <span>{{
                      formData.scmName ? formData.scmName : '--'
                    }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <hr v-if="listMetadata && listMetadata.length > 0" />
          <el-row>
            <el-col
              v-for="(item, index) in listMetadata"
              :key="index"
              :span="6"
            >
              <div style="font-size:16px;color:#888888">
                <span>{{ item.label }}</span>
                <p class="text-value">
                  {{ item.value ? item.value : '--' }}
                </p>
              </div>
            </el-col>
          </el-row>
          <hr />
          <div class="action d-flex">
            <div class="d-flex align-items-center">
              <div class="text-title">
                {{ $l('detail_label_stock') || 'Stock' }}：
              </div>
              <div class="text-value" style="font-size:22px;">
                <span>{{ formData.invNum ? formData.invNum : '0' }}</span>
              </div>
            </div>
            <button
              class="btn btn-outline-success"
              type="button"
              @click="addCart"
            >
              {{ $l('btn_addCart') || '加入购物车' }}
            </button>
            <button
              class="btn btn-outline-danger"
              style="margin-left: 10px;"
              type="button"
              @click="addCollect"
            >
              <i v-if="!formData.state" class="fa fa-heart-o"></i>
              <i v-else class="fa fa-heart" style="color: red"></i>
            </button>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mt-2">
      <sample-material :sampleCode="sampleCode" ref="contactTable" />
    </el-card>
  </div>
</template>
<script>
import SampleMaterial from '../sample-material'

export default {
  computed: {},
  components: { SampleMaterial },
  // 数据
  data() {
    return {
      sampleCode: '',
      formData: {},
      imageList: [],
      listMetadata: [],
      productType: 'S',
      activeName: 'first'
    }
  },
  activated() {
    this.sampleCode = this.$route.params.sampleCode
    this.query()
  },
  // 生命周期钩子
  mounted() {
    this.sampleCode = this.$route.params.sampleCode
    this.query()
  },
  // 事件处理方法
  methods: {
    query() {
      this.$api
        .digitalSampleInfoDetailApi({
          sampleCode: this.sampleCode
        })
        .then((res) => {
          // 产品基本信息
          this.formData = res.body.sampleDetail
          this.imageList = res.body.lsSampleInfoImageData
          this.listMetadata = res.body.listMetadata
        })
    },
    // 变换产品图
    changeImage(curImageUrl) {
      this.formData.defaultImageUrl = curImageUrl
    },
    // 点击大图显示图片预览组件
    imageView() {
      if (this.formData.defaultImageUrl) {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      }
    },
    // 加入收藏/取消收藏
    addCollect() {
      this.$api
        .saveAndCancelCollectApi({
          sampleCode: this.sampleCode,
          productType: this.productType
        })
        .then(() => {
          this.formData.state = true
          if (this.formData.state) {
            this.$message.success(this.$l('tips_collection_ok') || '收藏成功')
          } else {
            this.$message.success(
              this.$l('tips_collection_cancle') || '取消收藏'
            )
          }
        })
    },
    addCart() {
      this.$api
        .addCartApi({
          sampleCode: this.sampleCode,
          productType: this.productType
        })
        .then(() => {
          this.$message.success(
            this.$l('tips_add_cart_ok') || '购物车添加成功！'
          )
        })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.text-currency {
  font-size: 14px;
  color: #5a5a5a;
}
.text-title {
  width: 120px;
  color: #888888;
}
.text-value {
  width: 100%;
  color: #666666;
}
.table-c table {
  height: 30px;
}

.table-c table td {
  border-left: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
  border-right: 1px solid #f4f4f4;
  border-top: 1px solid #f4f4f4;
  padding-left: 5px;
  height: 30px;
}

.table-tr {
  background-color: #fbfcfd;
}

.on {
  background-color: #fbfcfd;
}

.time {
  font-size: 13px;
  color: #999;
}

.max-image {
  width: 100%;
  height: 100%;
  // max-width: 100%;
  // max-height: 320px;
  display: block;
}

.image {
  width: 100%;
  display: block;
}

.widget-thumb {
  padding: 20px;
  border-radius: 4px;
  height: 120px;
}

.widget-thumb.bordered {
  border: 1px solid #e7ecf1;
}

.widget-thumb .widget-thumb-heading {
  font-size: 14px;
  font-weight: bold;
  color: #8e9daa;
  margin: 0 0 20px 0;
}

.widget-thumb .widget-thumb-wrap {
  overflow: hidden;
}

.widget-thumb .widget-thumb-wrap .widget-thumb-icon {
  float: left;
  width: 60px;
  height: 60px;
  display: inline-block;
  font-size: 20px;
  line-height: 41px;
  color: #fff;
  text-align: center;
  padding: 10px;
  margin-right: 15px;
}

.widget-thumb .widget-thumb-body {
  overflow: hidden;
}

.widget-thumb .widget-thumb-body .widget-thumb-subtitle {
  padding-top: 2px;
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #8e9daa;
}

.widget-thumb .widget-thumb-body .widget-thumb-body-stat {
  display: block;
  font-size: 30px;
  font-weight: 600;
  color: #3e4f5e;
}

tr:hover {
  background: #f3f4f6;
}
</style>
